module.exports = __webpack_public_path__ + "static/media/Submission Bundle.737f68d7.png";